import {
    BitrixVue,
    nextTick
} from 'ui.vue3';

import { vplSiteStore } from '../../store/vplstore';
import { mapState } from 'ui.vue3.pinia';

import {
    hidePreloader,
    hideCatalogPreloader
} from '../../services/preloader/preloader';

import { EditBtns } from '../../services/editbtns/editbtns';
import { ItemEditBtns } from '../../services/itemeditbtns/itemeditbtns';

import { TitleBlock } from '../header/titleblock';
import { HtmlComponent } from '../htmlcomponent/htmlcomponent';
import { resolveComponent, resetLazyChoices, isLazyComponent, htmlPageComponent } from './lazy';


/*
 Страничные компоненты — по имени VUE_COMPONENT через resolveComponent (./lazy.js):
 уже загруженный отдается как есть, отсутствующая группа подгружается
 расширением Битрикса. HtmlComponent — в ядре, html-блоки есть на любой странице.
*/

export const App = {

    components: {

        EditBtns,
        ItemEditBtns,
        TitleBlock

    },

    data() {
        return {
            deferredRender: false
        };
    },

    computed: {

        ...mapState(vplSiteStore, [
            'struct',
            'type',
            'edit'
        ]),

        criticalStruct() {

            if (!this.struct) {
                return [];
            }

            return Object.entries(this.struct).slice(0, 3);
        },

        deferredStruct() {

            if (!this.struct) {
                return [];
            }

            return Object.entries(this.struct).slice(3);
        }
    },

    mounted() {

        nextTick(() => {

            hidePreloader();
            hideCatalogPreloader();

        });

        if ('requestIdleCallback' in window) {

            requestIdleCallback(() => {
                this.deferredRender = true;
            });

        } else {

            setTimeout(() => {
                this.deferredRender = true;
            }, 200);

        }
    },

    updated(){
        hidePreloader();
        hideCatalogPreloader();
    },

    watch: {

        struct() {

            // новая страница — выбор «обёртка или компонент» для блоков заново
            resetLazyChoices();

            requestAnimationFrame(() => {

                hidePreloader();
                hideCatalogPreloader();

            });

        }

    },

    methods: {

        getComponent(item, key) {

            const slotKey = item?.componentData?.KEY || key;

            if (item.type === 'html') {
                const named = htmlPageComponent(window.location.pathname);
                return named ? resolveComponent(named, slotKey) : HtmlComponent;
            }

            const componentName = item?.componentData?.VUE_COMPONENT;

            if (!componentName || !isLazyComponent(componentName)) {
                return null;
            }

            return resolveComponent(componentName, slotKey);
        }
    },

template: `
        <div class="vpl-app">
            <TitleBlock :structKey="'tblock'" :key="'tblockkey'" />
            <component
                v-for="[key, item] in criticalStruct"
                :is="getComponent(item, key)"
                :structKey="key"
                :key="item?.componentData?.KEY || key"
            />

            <template v-if="deferredRender">

                <component
                    v-for="[key, item] in deferredStruct"
                    :is="getComponent(item, key)"
                    :structKey="key"
                    :key="item?.componentData?.KEY || key"
                />

            </template>

        </div>
    `
};